import { isLivePagesFeatureEnabled } from './isLivePagesFeatureEnabled';
import { useIsLivePageRaw } from './LivePagesStore';

/**
 * Checks that current page is a live page and that live pages feature flag is enabled
 * @returns boolean
 */
export const useIsLivePage = (): boolean => {
	const isLivePagesEnabled = isLivePagesFeatureEnabled();
	const [isLive] = useIsLivePageRaw();
	return isLivePagesEnabled && isLive;
};
